import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUsers } from "../../services/api"; // Asegúrate de tener esta función en tu archivo api.js
import Breadcrumbs from "../../components/BreadCrumbs";

const UserList = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUsers();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Users", url: "/dashboard/users" },
  ];

  return (
    <>
      <h2>Lista de Usuarios</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <Link to={`/dashboard/users/create`} className="btn btn-primary mb-3">
        Crear usuario
      </Link>

      {users && users.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Email</th>
              <th>Rol</th>
              <th>Equipo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.usuario_id}>
                <td>{user.usuario_id}</td>
                <td>{user.nombre}</td>
                <td>{user.email}</td>
                <td>{user.rol}</td>
                <td>{user.equipo}</td>
                <td>
                  <Link
                    to={`update/${user.usuario_id}`}
                    className="btn btn-sm btn-secondary ml-2"
                  >
                    Editar
                  </Link>
                  <Link
                    to={`delete/${user.usuario_id}`}
                    className="btn btn-sm btn-danger ml-2"
                  >
                    Eliminar
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay usuarios disponibles.</p>
      )}
    </>
  );
};

export default UserList;
